import React from 'react';

type StatsCardProps = {
  title: string;
  value: number | string;
  description: string;
  icon: React.ReactNode;
  variant?: 'default' | 'warning' | 'success';
};

const variantStyles = {
  default: {
    bg: 'bg-white',
    iconBg: 'bg-blue-50',
    iconText: 'text-blue-600',
    valueBg: '',
  },
  warning: {
    bg: 'bg-amber-50 border-amber-200',
    iconBg: 'bg-amber-100',
    iconText: 'text-amber-600',
    valueBg: 'text-amber-700',
  },
  success: {
    bg: 'bg-emerald-50 border-emerald-200',
    iconBg: 'bg-emerald-100',
    iconText: 'text-emerald-600',
    valueBg: 'text-emerald-700',
  },
};

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  description,
  icon,
  variant = 'default',
}) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={`${styles.bg} rounded-xl border border-gray-200 p-5 transition-all hover:shadow-md`}
      role="status"
      aria-label={`${title}: ${value}`}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">
            {title}
          </p>
          <p className={`text-2xl font-bold ${styles.valueBg || 'text-gray-900'}`}>
            {value}
          </p>
          <p className="text-xs text-gray-500">{description}</p>
        </div>
        <div className={`${styles.iconBg} ${styles.iconText} p-2.5 rounded-lg`}>
          {icon}
        </div>
      </div>
    </div>
  );
};
